import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
// import { routerMiddleware, push } from 'react-router-redux';
import { createLogger } from 'redux-logger';
import rootReducer from '../reducers';

let createStoreWithMiddleware;

if (process.env.NODE_ENV === 'production') {
    createStoreWithMiddleware = applyMiddleware(thunk)(createStore);
} else {
    createStoreWithMiddleware = applyMiddleware(
        thunk,
        createLogger({ level: 'info', collapsed: true }),
    )(createStore);
}

export default function configureStore(initialState) {
    const store = createStoreWithMiddleware(rootReducer, initialState);

    if (module.hot) {
        module.hot.accept('../reducers', () =>
            store.replaceReducer(require('../reducers')) // eslint-disable-line global-require
        );
    }

    return store;
}



// WEBPACK FOOTER //
// ./src/store/configureStore.js